import React from "react";
import WeatherTemperature from "./WeatherTemperature";

function WeatherInfo({weatherData,currentTime}) {
    return (
<div className="weatherInfo">
        <h1>{weatherData.city}</h1>
        <ul>
         <li>
  {currentTime.toLocaleString("en-US", { weekday: "long", hour: "2-digit", minute: "2-digit" })}
</li>
          <li className="text-capitalize">{weatherData.condition}</li>
        </ul>

       <div className="row">
        <div className="col-6 d-flex align-items-center">
          <img
            src={`https://shecodes-assets.s3.amazonaws.com/api/weather/icons/${weatherData.icon}.png`}
            alt={weatherData.icon}
          />
          <WeatherTemperature celsius={weatherData.temperature} />
        </div>

          <div className="col-6">
            <ul>
              <li>Humidity: {weatherData.humidity}%</li>
              <li>Wind:{weatherData.wind}</li>
            </ul>
          </div>
        </div>
</div>        
    )
}

export default WeatherInfo